import { call, put } from "redux-saga/effects";
import { GraphQLServerError } from "~/common/graphql/GraphQLServerError";
import { logError } from "~/common/logging";
import type { HandlingConfiguration } from "~/Redux/Actions/errorActions";
import { parseApiError } from "~/Redux/Actions/errorActions";

export function* handleApiError(e: Partial<JQuery.jqXHR> | GraphQLServerError, configuration?: HandlingConfiguration) {
    // we call this generator when are going to suppress errors,
    // so saga extension won't log this error and we need to do it manually
    yield call(logError, e as Error);

    let errorAction = parseApiError(e, configuration);
    if (errorAction) {
        yield put(errorAction);
    }
}
